import * as Types from '../../constants/actionTypes';
import AuthAxios from '../../models/Axios'
import { LOCAL_URL, API_REQUESTS, } from '../../helper/constant'
import { NO_ACCESS_PORTAL_CODE } from '../../constants/permissions'
// import Auth from '../../models/Auth';



export const REQUEST_LIST = (payload) => async (dispatch) => {
  //console.log("programe Id", portalId, "Request id ", requestTypeId)
  // const {currentPage=1,itemsPerPage=10} = filterObj;
  dispatch({ type: Types.REQUEST_LIST });
  try {
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/getRequests`, payload)
    dispatch({
      type: Types.REQUEST_LIST_SUCCESS,
      payload: response.data && response.data.data,
      additionalData: response.data && response.data.additionalData,
      // requestYears: response.data && response.data.years,
      // requestStatuses: response.data && response.data.statuses,
      // requestListCount: response.data && response.data.count,
      allRequest: response.data && response.data.allRequest
    })
  } catch (error) {
    dispatch({ type: Types.REQUEST_LIST_ERROR, payload: error })
  }
}

/** Dashboard charts: aggregates only (no full list). Silent — no global loading overlay. */
export const DASHBOARD_REQUEST_SUMMARY = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.post(
      `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/dashboardRequestSummary`,
      payload,
      { skipLoadingOverlay: true },
    );
    const data = response.data || {};
    dispatch({
      type: Types.REQUEST_LIST_SUCCESS,
      payload: [],
      allRequest: null,
      requestListCount: data.count || 0,
      requestYears: data.years || [],
      dashboardSummary: data,
    });
    return data;
  } catch (error) {
    dispatch({ type: Types.REQUEST_LIST_ERROR, payload: error });
    return null;
  }
}

export const GET_REQUEST_FILTER_OPTIONS = () => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/requestFilterOptions`)
    dispatch({ type: Types.REQUEST_FILTER_OPTIONS_SUCCESS, payload: response.data })
  } catch (exception) {
    dispatch({ type: Types.REQUEST_FILTER_OPTIONS_ERROR, payload: exception.message })
  }
}


export const REQUEST_COUNT = (payload) => (dispatch) => {
  dispatch({ type: Types.REQUEST_COUNT });
  AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/countRequests`, payload)
    .then((response) => dispatch({
      type: Types.REQUEST_COUNT_SUCCESS,
      payload: response.data && response.data.data 
    }))
    .catch(error => dispatch({ type: Types.REQUEST_COUNT_ERROR, payload: error }))
}

export const GET_PROGRAM_DATA = (payload) => async (dispatch) => {
  try {
    const { portalId } = payload
    if (!portalId) {
      return;
    }

    const programData = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PROGRAMS}/getPortal/${portalId}`)
    console.log(`programData is:`, programData.data);
    dispatch({
      type: Types.PROGRAM_DATA,
      programData: programData.data && programData.data.data
    })
    // if (programData) {
    //   Auth.viewPBI(programData.data && programData.data.data)
    // }
  } catch (exception) {
    if (exception.portalCode && exception.portalCode === NO_ACCESS_PORTAL_CODE) {
      // console.log(`fetch program by id trojan`, exception)
      AuthAxios.unauthorizedTrozenAccess()
    }
    dispatch({ type: Types.PROGRAM_ERROR, programError: exception.message })
  }
}

export const CLEAR_PROGRAM_DATA = () => (dispatch) => {
  dispatch({ type: Types.PROGRAM_DATA, programData: [] })
}
/* Get All Statuses for dropdown list */
export const GET_ALL_STATUSES = () => async (dispatch) => {
  try {
    const allStatuses = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.STATUSES}`);
    dispatch({ type: Types.STATUSES_DATA, statusData: allStatuses?.data?.data });
  } catch (exception) {
    dispatch({ type: Types.STATUSES_ERROR, statusError: exception.message });
  }
}
export const GET_ALL_STATUSES_BY_REQUEST_LIST = (payload) => async (dispatch) => {
  try {
    const { portalId } = payload
    if (!portalId) {
      return;
    }
    const allStatuses = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STAGE_STATUS}/listPortalStageStatusListByRequestList`, { params: payload });
    dispatch({ type: Types.STATUSES_LIST, statusList: allStatuses?.data?.data });
  } catch (exception) {
    dispatch({ type: Types.STATUSES_ERROR, statusError: exception.message });
  }
}

export const REQUEST_STATUSES_LIST = (portalId) => async (dispatch) => {
  try {
    const allStatuses = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.STATUSES}/fetchRequestStageStatuses`, { params: { portalId: portalId } });
    dispatch({ type: Types.REQUEST_STATUS_DATA, listStatusData: allStatuses.data });
  } catch (exception) {
    dispatch({ type: Types.REQUEST_STATUS_ERROR, statusErr: exception.message });
  }
}
/*  Set Portal Error */
export const SET_PORTAL_ERROR = (message) => (dispatch) => {
  dispatch({ type: Types.PROGRAM_ERROR, programError: message })

}

export const CHART_REQUEST_STATUS = (payload) => async (dispatch) => {
  return AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/requestStatusforChart`, { params: payload })
    .then((response) => dispatch({
      type: Types.CHART_REQUEST_STATUS_SUCCESS,
      payload: response.data.data
    }))
    .catch(error => dispatch({ type: Types.CHART_REQUEST_STATUS_ERROR, payload: error }))
}

export const CHART_REQUEST_TYPE = (payload) => async (dispatch) => {
  return AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/requestTypesforChart`, { params: payload })
    .then((response) => dispatch({
      type: Types.CHART_REQUEST_TYPE_SUCCESS,
      payload: response.data.data
    }))
    .catch(error => dispatch({ type: Types.CHART_REQUEST_TYPE_ERROR, payload: error }))
}


export const LIST_ALL_PO = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PO_URL}/getpobyportalId`, { params: payload });
    dispatch({ type: Types.LIST_ALL_PO, poList: response.data.data })
  } catch (exception) {

    dispatch({ type: Types.PO_LIST_ERROR, poError: exception.message })
  }
}

export const GET_PO_DETAIL_BY_ID = (payload) => async (dispatch) => {

  try {
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.PO_URL}/getPoDetailsbyId`, payload);
    dispatch({
      type: Types.PO_DETAIL_DATA,
      onePodetails: response.data.data
    })
  } catch (error) {
    dispatch({ type: Types.PO_LIST_ERROR, poError: error.message })
  }

}

export const GET_ASSETS_DETAILS = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.NEW_REQUEST_ASSET}/assetsCounts`, payload);
    dispatch({
      type: Types.GET_ASSETS_COUNT_DATA,
      payload: response.data.data
    })
  } catch (error) {
    dispatch({ type: Types.GET_ASSETS_COUNT_ERROR, assetcounterror: error.message })
  }
}

export const GET_ALL_ASSETS = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.NEW_REQUEST_ASSET}/getAllAsset`, payload);
    dispatch({
      type: Types.GET_ASSETS_COUNT_DATA,
      payload: response.data.data
    })
  } catch (error) {
    dispatch({ type: Types.GET_ASSETS_COUNT_ERROR, assetcounterror: error.message })
  }
}

export const GET_ASSETS_DETAILS_CHART = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.NEW_REQUEST_ASSET}/assetsCountsChart`, { params: payload });
    dispatch({
      type: Types.GET_ASSETS_COUNT_DATA,
      payload: response.data.data
    })
    return response;
  } catch (error) {
    dispatch({ type: Types.GET_ASSETS_COUNT_ERROR, assetcounterror: error.message })
    return error;
  }
}

export const GET_REQUEST_IDS = (payload) => (dispatch) => {
  // dispatch({type: Types.REQUEST_COUNT});
  AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/fetchRequestIds`, { params: payload })
    .then((response) => dispatch({
      type: Types.REQUEST_IDS_SUCCESS,
      requestIds: response.data && response.data.data
    }))
    .catch(error => dispatch({ type: Types.REQUEST_COUNT_ERROR, payload: error }))
}


export const DELETE_REQUEST = (payload) => (dispatch) => {
  return AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/deleteRequest`, payload)
    .then((response) => {
      dispatch({
        type: Types.REQUEST_IDS_SUCCESS,
        requestIds: response.data
      });
      return response.data;
    }).catch((error) => {
      dispatch({ type: Types.REQUEST_COUNT_ERROR, payload: error });
      throw error;
    });
};

export const CREATE_REQ_BY_TEMPLATE = (payload) => (dispatch) => {
  return AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/createbytemplate`, payload);
}



